import { changeQuota } from '@/enteties/tariff/api';
import { useMutation } from '@tanstack/react-query';
import * as m from '@paraglide/messages';
import { useApiStatusToast } from '@/shared/hooks/useApiStatusToast';

export const useChangeQuota = () => {
  const [success, error] = useApiStatusToast();

  return useMutation({
    mutationFn: changeQuota,
    onSuccess: () => {
      success({
        title: m.api_status_toast_success(),
      });
    },
    onError: (e) => {
      error({
        title: m.api_status_toast_error(),
        description: e.message,
      });
    },
  });
};
